import { render } from "./BlogEtiqueta.vue?vue&type=template&id=7dec8189"
import script from "./BlogEtiqueta.vue?vue&type=script&lang=js"
export * from "./BlogEtiqueta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__